import { render, staticRenderFns } from "./LeaderboardStartButton.vue?vue&type=template&id=3606cc34"
import script from "./LeaderboardStartButton.vue?vue&type=script&lang=js"
export * from "./LeaderboardStartButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports